
import { useEffect, useState } from "react";

import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectAccountOnboarding, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { PayoutAPI } from "../../api/PayoutAPI";

import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { AccountSetupAPI } from "../../api/AccountSetupAPI";
import { PaymentAPI } from "../../api/PaymentAPI";
import Loader from "../../component/Loader";
import { vendorStepPayload } from "../../util/accountSetup";


const rootStyle = getComputedStyle(document.documentElement);
const btnBackgroundColor = rootStyle.getPropertyValue("--hoverColorBold").trim();

const appearance = {
    variables: {
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        colorPrimary: btnBackgroundColor,
        buttonPrimaryColorText: "#000",
        buttonPrimaryColorBackground: btnBackgroundColor
    },

};

const AccountOnboardingUI = () => {
    const userInfo = useSelector((store)=>store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [stripeConnectInstance, setStripeConnectInstance] = useState(() => { });
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const stepperInStore = useSelector((state) => state.stepper);
    const stepperConfigId = stepperInStore.configId;


    const userInfoReq = {
        userId: userInfo.userId,
        clubId: selectedClub?.clubId
    }

    const fetchClientSecret = async () => {
        const { Data: clientSecret } = await PayoutAPI.postAdminOnBoarding(userInfoReq)

        return clientSecret
    }

    const getPublishKey = async () => {
        return await PaymentAPI.getPublishKey();
    }

    //// TODO //// 
    const initializeStripeConnect = async (publishKey) => {
        const stripeInstance = loadConnectAndInitialize({
            publishableKey: publishKey,
            fetchClientSecret: fetchClientSecret,
            appearance: appearance
        });
        setStripeConnectInstance(stripeInstance);
        setIsLoading(false);
    };

    const updateStepper = async () => {
        try {
            await AccountSetupAPI.postStepper(vendorStepPayload(selectedClub.clubId));
        } catch (error) {
            console.error(error);
            
        }finally{
            navigate('/account-setup');
        }
    }

    useEffect(() => {
        setIsLoading(true)
        getPublishKey().then((resp => {
            initializeStripeConnect(resp.Data);
        }));
    }, []);

    const onComplete = () => {
        updateStepper();
    }

    return (
        <>
            {isLoading && <Loader />}
            {
                stripeConnectInstance && <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                    <div className="connect-account-onboarding">
                        <ConnectAccountOnboarding onExit={onComplete} />
                    </div>
                </ConnectComponentsProvider>
            }
        </>
    );
}
export default AccountOnboardingUI;
